/**
 * Check the validity of the share form
 *
 * @param  {Object} state
 * @return {Boolean}
 */
export const shareFormIsValid = (state) => {
    let format = /[^\s@]+@[^\s@]+\.[^\s@]+/

    return format.test(state.form.email) && state.form.level !== null
}

export default {
    shareFormIsValid
}



// WEBPACK FOOTER //
// ./src/state/modules/projects/share/getters.js